
const LimitInfo = function(props) {
	let dailyUsage = props.dailyUsage || 0;
	let dailyLimit = props.dailyLimit || 0;
	let monthlyUsage = props.monthlyUsage || 0;
	let monthlyLimit = props.monthlyLimit || 0;
	let permanentUsage = props.permanentUsage || 0;
	let permanentLimit = props.permanentLimit || 0;
	let plan = props.planName || '';
	let creditCount = props.credits || 0;

	const daily = dailyLimit ? (<li><b>{window?.t?.DAILY_LIMIT}:</b> {dailyUsage}/{dailyLimit}</li>) : null;
	const monthly = monthlyLimit ? (<li><b>{window?.t?.MONTHLY_LIMIT}:</b> {monthlyUsage}/{monthlyLimit}</li>) : null;
	const permanent = permanentLimit ? (<li><b>{window?.t?.TOTAL_LIMIT}:</b> {permanentUsage}/{permanentLimit}</li>) : null;
	const planInfo = plan ? (<li><b>{window?.t?.PLAN_NAME}:</b> {plan}</li>) : null;
	const creditInfo = (<li><b>{window?.t?.CREDITS_LEFT}:</b> {creditCount}</li>);

	return (
		<ul className="summary">{daily}{monthly}{permanent}{planInfo}{creditInfo}</ul>
	)
}

export default LimitInfo;